// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
// @ constants
const { CAMPAIGN_PRICING_CHANNEL } = require('constants/index');
const actionTypes = require('constants/actionTypes');
// @ actions
const { requestPromotion } = require('actions/promotions');

const advancedInterstitialPromotionsIsFetching = () => ({
    type: actionTypes.ADVANCED_INTERSTITIAL_GET_PROMOTION_REQUEST
});

const advancedInterstitialPromotionsFailure = (error) => ({
    type: actionTypes.ADVANCED_INTERSTITIAL_GET_PROMOTION_FAILURE,
    payload : {
        error
    }
});

const advancedInterstitialPromotionsSuccess = (response) => ({
    type: actionTypes.ADVANCED_INTERSTITIAL_GET_PROMOTION_SUCCESS,
    payload : {
        response
    }
});

const getAdvancedInterstitialPromotions = (nid, callOnboardingAPI) => (dispatch, getState) => {
    dispatch(advancedInterstitialPromotionsIsFetching());

    const params = {
        header: {
            version: 2,
        },
        query: {
            channel: CAMPAIGN_PRICING_CHANNEL,
            lang: getLanguage().toLowerCase(),
            nid
        }
    };

    return APIGet({
        dispatch,
        endpoint: 'getAdvancedInterstitialPromotions',
        params
    })
        .then(response => {
            dispatch(advancedInterstitialPromotionsSuccess(response.data));
            const immAdvancedInterstitialPromotions = getState().advancedInterstitialPromotions;
            const promoCode = immAdvancedInterstitialPromotions.getIn(['promotions', 'promoCode']);
            !!callOnboardingAPI && !!promoCode && dispatch(requestPromotion(promoCode));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(advancedInterstitialPromotionsFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getAdvancedInterstitialPromotions
};
